import ChatIcon from "@mui/icons-material/Chat";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MonitorIcon from "@mui/icons-material/Monitor";
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Chip,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { memo, useEffect, useRef, useState } from "react";
import ApiFetch from "../components/ApiFetch.js";
import ButtonControl from "../components/controls/ButtonControl.js";
import InputControl from "../components/controls/InputControl.js";
import PopupDialog from "../components/PopupDialog.js";
import { API_CUSTOMERS, API_MSGS } from "../context/ApiEndPoints";
import useAppContext from "../hooks/useAppContext.js";
import useFetchList from "../hooks/useFetchList.js";
import { stringAvatar } from "../scripts/Scripts.js";

function MsgsCard(props) {
  const { user, hubCon } = useAppContext();
  const containerRef = useRef();
  const [popupDialog, setPopupDialog] = useState(false);
  const [popupContent, setPopupContent] = useState(null);
  const [recivedMsg, setRecivedMsg] = useState();
  const [isSaving, setIsSaving] = useState(false);

  const [msgObj, setMsgObj] = useState({
    userNumber: null,
    customerNumber: null,
    numSegments: 1,
    msgBody: "",
  });

  const {
    records: selectedCustomer,
    isLoading: selectedCustomerIsLoading,
    fetchError: selectedCustomerFetchError,
  } = useFetchList(`${API_CUSTOMERS}/Quote/${props.quoteId}`);

  const { records, setRecords, isLoading, fetchError } = useFetchList(
    `${API_MSGS}/Customer/${selectedCustomer && selectedCustomer.customerId}`
  );

  const IncomingMsg = async () => {
    try {
      hubCon.on("RecieveMsg", (msg) => {
        setRecivedMsg(msg);
      });
    } catch (e) {
      console.error(e);
    }
  };

  // start / close websocket hubCon
  useEffect(() => {
    if (hubCon?.state === "Connected") {
      try {
        (async () => await IncomingMsg())();
      } catch (e) {
        console.error(e);
      }
    }

    return () => {};
    // eslint-disable-next-line
  }, [hubCon]);

  useEffect(() => {
    if (recivedMsg) {
      if (
        selectedCustomer &&
        recivedMsg.customerNumber === selectedCustomer.phoneNumber
      ) {
        setRecords((prev) => [...prev, recivedMsg]);
      }
    }

    return () => {};
    // eslint-disable-next-line
  }, [recivedMsg]);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      const { scrollHeight, clientHeight } = containerRef.current;
      containerRef.current.scrollTo({
        left: 0,
        top: scrollHeight - clientHeight,
        behavior: "smooth",
      });
    }

    return () => {};
  }, [records]);

  let val;
  const dateDivider = (nv) => {
    if (nv !== val) {
      val = nv;
      return (
        <Divider light sx={{ my: 1 }}>
          <Chip variant="outlined" label={val} />
        </Divider>
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    // POST request using fetch
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + user.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(msgObj),
    };
    const results = await ApiFetch(API_MSGS, requestOptions);

    if (results) {
      setRecords([...records, results]);
      setMsgObj({ ...msgObj, msgBody: "" });
    }
    setIsSaving(false);
  };

  return (
    <>
      {selectedCustomerFetchError ||
        (selectedCustomerIsLoading && (
          <CircularProgress size={20} color="inherit" sx={{ m: 2 }} />
        ))}
      {records && (
        <>
          <List component={Paper} disablePadding>
            <ListItem>
              <ListItemAvatar>
                <Avatar
                  {...stringAvatar(
                    selectedCustomer && selectedCustomer?.firstName
                  )}
                />
              </ListItemAvatar>
              <ListItemText
                primary={
                  selectedCustomer &&
                  `${selectedCustomer?.firstName} ${selectedCustomer?.lastName}`
                }
                secondary={
                  selectedCustomer && (
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="subtitle2"
                        sx={{
                          color: "text.primary",
                          display: "inline",
                        }}
                      >
                        {selectedCustomer?.email}
                      </Typography>{" "}
                      | {selectedCustomer?.phoneNumber}
                    </React.Fragment>
                  )
                }
              />
            </ListItem>
          </List>
          <Box
            ref={containerRef}
            boxShadow={1}
            sx={{
              p: 2,
              bgcolor: "lavenderblush",
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              height: "66vh",
              overflow: "auto",
            }}
          >
            {records.length === 0 && <ListSubheader>No records.</ListSubheader>}
            {records.map((e, i) => (
              <Box key={i}>
                {dateDivider(
                  dayjs(e.createdDate).calendar(null, {
                    sameDay: "[Today]",
                    lastDay: "[Yesterday]",
                    lastWeek: "dddd",
                    sameElse: "DD/MM/YYYY",
                  })
                )}
                {e.isRecieved ? (
                  <Stack
                    alignItems="flex-start"
                    direction={"row"}
                    sx={{ pb: 1 }}
                  >
                    <Box component={Paper}>
                      <Box p={2}>
                        {e.msgBody.includes("/Recordings/") ? (
                          <audio controls name="media">
                            <source src={e.msgBody} type="audio/x-wav" />
                          </audio>
                        ) : (
                          <Typography
                            sx={{
                              whiteSpace: "pre-line",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {e.msgBody}
                          </Typography>
                        )}
                        {e.medias &&
                          e.medias.map((item) => (
                            <Card
                              variant="outlined"
                              sx={{ maxWidth: 256, marginBottom: 2 }}
                            >
                              <CardActionArea
                                onClick={() => {
                                  setPopupContent(item);
                                  setPopupDialog(true);
                                }}
                              >
                                <CardMedia
                                  height="100%"
                                  component="img"
                                  image={item}
                                  alt={item}
                                  loading="lazy"
                                />
                              </CardActionArea>
                            </Card>
                          ))}
                      </Box>
                      <Divider light />
                      <Stack
                        alignItems="flex-start"
                        direction={"row-reverse"}
                        justifyContent="space-between"
                        spacing={2}
                        p={0.5}
                        px={2}
                      >
                        <Typography variant="caption" color="text.secondary">
                          {dayjs(e.createdDate).format("LT")}
                          {e.fromCity &&
                            ` | ${e.fromCity} : ${e.fromCountry}`}{" "}
                        </Typography>
                        {e.msgType === "Web" ? (
                          <MonitorIcon
                            fontSize="inherit"
                            sx={{ color: "text.secondary" }}
                          />
                        ) : (
                          <ChatBubbleOutlineIcon
                            fontSize="inherit"
                            sx={{ color: "text.secondary" }}
                          />
                        )}
                      </Stack>
                    </Box>
                  </Stack>
                ) : (
                  <Stack
                    alignItems="flex-start"
                    direction={"row-reverse"}
                    sx={{ pb: 1 }}
                  >
                    <Box
                      component={Paper}
                      variant="outlined"
                      sx={{ p: 2, bgcolor: "AliceBlue" }}
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          align="right"
                        >
                          {e.userNumber}
                          <br />
                          {dayjs(e.createdDate).format("LT")}
                        </Typography>
                        <Avatar
                          {...stringAvatar(e.userNumber)}
                          variant="square"
                        />
                      </Stack>
                      <Divider light sx={{ my: 1 }} />
                      {e.msgBody.startsWith("/Recordings/") ? (
                        <audio controls name="media">
                          <source src={e.msgBody} type="audio/x-wav" />
                        </audio>
                      ) : (
                        <Typography
                          sx={{
                            whiteSpace: "pre-line",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {e.msgBody}
                        </Typography>
                      )}
                    </Box>
                  </Stack>
                )}
              </Box>
            ))}
          </Box>
          <Paper sx={{ p: 2 }}>
            <form onSubmit={handleSubmit}>
              <Stack direction="row">
                <InputControl
                  label="Type a message"
                  name="msgBody"
                  value={msgObj.msgBody}
                  onChange={(e) =>
                    setMsgObj({
                      ...msgObj,
                      userNumber: selectedCustomer && user.twilioNumber,
                      customerNumber: selectedCustomer?.phoneNumber,
                      msgBody: e.target.value,
                    })
                  }
                  helperText={`CHARACTERS: ${msgObj.msgBody.length}`}
                  FormHelperTextProps={{ style: { fontSize: "medium" } }}
                  multiline
                  required
                  sx={{ m: 0 }}
                />
                <ButtonControl
                  type="submit"
                  endIcon={<ChatIcon />}
                  isSaving={isSaving}
                />
              </Stack>
            </form>
          </Paper>
        </>
      )}
      <PopupDialog popupDialog={popupDialog} setPopupDialog={setPopupDialog}>
        <img src={popupContent} alt={popupContent} />
      </PopupDialog>
    </>
  );
}

export default memo(MsgsCard);
